export class Text {
    name: string;
    group: string;
    value: string;
}
